import {
  addVpsAddons,
  removeVpsAddons,
  addCustomfieldVps,
  removeCustomfieldVps,
} from "features/common/layouts/cartSlice";
import { selectProduct } from "features/common/products/productsSlice";
import { updateOperatingSystem, vpsSelector } from "features/vps/vpsSlice";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { notifyWarning } from "components/ToastMessage";

const AddonsVPSDropdown = (props) => {
  const dispatch = useDispatch();
  const [optValue, setOptValue] = useState("choose");
  const {
    label,
    optionData,
    setSelectOS,
    setCurrentOS,
    setCurrentPanel,
    setCurrentBackup,
    setCurrentSupport,
    setCurrentOthers,
    setCurrentSoftaculous,
    currentOSBundle,
    currentBundlingPanel,
    setBundlePromo,
    setCurrentOSBundle,
  } = props;
  const currentProduct = useSelector(selectProduct);
  const vps = useSelector(vpsSelector);
  const { pid: pidOnCart, name: currentProdName } = currentProduct.current;
  const { productsList } = useSelector((state) => state.cart);

  const [listData, setListData] = useState({
    operatingsystem: null,
    controlpanel: null,
    softaculous: null,
    supportlevel: null,
    advancedbackup: null,
    others: null,
  });

  useEffect(() => {
    switch (label) {
      case "Operating System":
        setListData((prevState) => ({
          ...prevState,
          operatingsystem: optionData.filter(
            (item) =>
              item.category === "Software" &&
              item.input_name === "Operating System"
          ),
        }));
        break;
      case "Control Panel":
        setListData((prevState) => ({
          ...prevState,
          controlpanel: optionData.filter(
            (item) =>
              item.category === "Software" &&
              item.input_name === "Control Panel"
          ),
        }));
        break;
      case "Softaculous":
        setListData((prevState) => ({
          ...prevState,
          softaculous: optionData.filter(
            (item) =>
              item.category === "Software" && item.input_name === "Softaculous"
          ),
        }));
        break;
      case "Support Level":
        setListData((prevState) => ({
          ...prevState,
          supportlevel: optionData.filter(
            (item) => item.category === "Support-Level"
          ),
        }));
        break;
      case "Advanced Backup":
        setListData((prevState) => ({
          ...prevState,
          advancedbackup: optionData.filter(
            (item) =>
              item.category === "Backup" &&
              (item.name.endsWith(currentProdName?.substr(0, 4).trim()) ||
                item.name.endsWith("Backup"))
          ),
        }));
        break;
      default:
        setListData((prevState) => ({
          ...prevState,
          others: optionData.filter((item) => item.category === "Others"),
        }));
        break;
    }
  }, [label, optionData, currentProdName]);

  useEffect(() => {
    // console.log('currentOSBundle', currentOSBundle);
    // currentOSBundle 128 == Almalinux
    if (currentOSBundle !== 128 || currentOSBundle === 128) {
      const addonItem =
        optionData?.find((item) => item.id === +currentOSBundle) ?? null;
      const checkOS = addonItem?.input_name === "Operating System" ?? false;
      if (checkOS) {
        setSelectOS({ type: "SET_OS", payload: { os: addonItem } });
        setCurrentOS(addonItem);
        setOptValue(currentOSBundle);
        dispatch(updateOperatingSystem(addonItem.name));
      }
    } else if (currentOSBundle === 0) {
      setOptValue("choose");
      setBundlePromo("choose");
    }
  }, [currentOSBundle, dispatch, optionData, setBundlePromo, setCurrentOS, setSelectOS]);

  useEffect(() => {
    if (currentBundlingPanel) {
      const addonItem =
        optionData?.find((item) => item.id === +currentBundlingPanel) ?? null;
      const checkPanel = addonItem?.input_name === "Control Panel" ?? false;
      if (checkPanel) {
        setTimeout(() => {
          setCurrentPanel(addonItem);
          setOptValue(currentBundlingPanel);
          dispatch(addVpsAddons({ pid: pidOnCart, addons: addonItem }));
        }, 500);
      }
    } else if (currentBundlingPanel === 0) {
      setCurrentPanel(false);
      setOptValue("choose");
      setBundlePromo("choose");
    }
  }, [currentBundlingPanel, dispatch, optionData, pidOnCart, setBundlePromo, setCurrentPanel]);

  const optionHandler = (e) => {
    const selectedOptionId = e.target.options[e.target.selectedIndex].id;
    const selectedValue = e.target.value;
    // console.log ('selectedValue', selectedValue);
    const addonItem = optionData?.find((item) => item.id === +selectedValue) ?? null;

    const isOperatingSystem = addonItem?.input_name === "Operating System";
    const isAdvancedBackup = addonItem?.input_name === "Backup"; // Fix: API uses "Backup" not "Advanced Backup"
    const isSupportLevel = addonItem?.input_name === "Support Level";
    const isControlPanel = addonItem?.input_name === "Control Panel";
    const isSoftaculous = addonItem?.input_name === "Softaculous";
    const isOthers = addonItem?.input_name === "Others";

    if (selectedOptionId.includes("Operating System")) {
      dispatch(updateOperatingSystem(selectedOptionId));
    }

    setOptValue(selectedValue);

    if (!addonItem && selectedValue === "choose" && productsList.length === 0) {
      return;
    }

    if (productsList.length === 0 && selectedValue !== "choose") {
      if (isOperatingSystem) {
        setSelectOS({ type: "SET_OS", payload: { os: addonItem } });
        if (selectedValue !== 128) {
          setBundlePromo("choose");
          setCurrentOSBundle(selectedValue);
          dispatch(removeVpsAddons({ pid: pidOnCart, input: "Others" }));
        }
        setCurrentOS(addonItem);
        return;
      }

      notifyWarning(
        "Tambahkan produk VPS terlebih dahulu pada keranjang untuk menambahkan addons"
      );
      return;
    }

    if (selectedValue === "choose") {
      let inputLabel = null;
      if (["Operating System", "Control Panel"].includes(label)) {
        setBundlePromo("choose");
        inputLabel = label === "Operating System" ? "Operating System" : "Control Panel";
      } else if (label === "Softaculous") {
        inputLabel = "Softaculous";
      } else if (label === "Support Level") {
        inputLabel = "Support Level";
      } else if (label === "Advanced Backup") {
        inputLabel = "Backup"; // Fix: API uses "Backup" not "Advanced Backup"
      } else {
        inputLabel = "Others";
      }
      
      if (inputLabel) {
        dispatch(removeVpsAddons({ pid: pidOnCart, input: inputLabel }));
      }
      
      // Remove Operating System custom field if it's Operating System being reset
      if (label === "Operating System") {
        currentProduct.current.customfields.customfield
          .filter((field) => field.name === "Operating System")
          .forEach((field) => dispatch(removeCustomfieldVps({ pid: pidOnCart, id: field.id })));
      }
      return;
    }

    dispatch(addVpsAddons({ pid: pidOnCart, addons: addonItem }));

    if (isOperatingSystem) {
      currentProduct.current.customfields.customfield
        .filter((field) => field.name === "Operating System")
        .forEach((field) =>
          dispatch(addCustomfieldVps({ pid: pidOnCart, id: field.id, value: addonItem.name }))
        );
    }

    if (isControlPanel) {
      setCurrentPanel(addonItem);
      if (![92, 157, 191].includes(+selectedValue)) {
        setBundlePromo("choose");
      }
      return;
    }

    if (isSoftaculous) {
      setCurrentSoftaculous(addonItem);
      return;
    }

    if (isSupportLevel) {
      setCurrentSupport(addonItem);
      return;
    }

    if (isAdvancedBackup) {
      setCurrentBackup(addonItem);
      return;
    }

    if (isOthers) {
      setCurrentOthers(addonItem);
      return;
    }

    if (isOperatingSystem) {
      setCurrentOS(addonItem);
      if (selectedValue !== 128) {
        setBundlePromo("choose");
        setCurrentOSBundle(selectedValue);
        dispatch(removeVpsAddons({ pid: pidOnCart, input: "Others" }));
      }
    }
  };

  const AddonOptions = ({ data, label }) => {
    const options = data[label.toLowerCase().replace(/\s/g, "")] || [];

    if (!options) {
      return;
    }

    if (options.length === 0) {
      return (
        <option value="na" className="text-muted">
          Tidak Tersedia
        </option>
      );
    }

    return (
      <>
        {label === "Support Level" ? (
          <option value="choose">Self Manage</option>
        ) : label === "Control Panel" ? (
          <option value="choose">Tanpa Panel</option>
        ) : (
          <option value="choose">Pilih...</option>
        )}
        {vps.operatingSystem === "Operating System - Debian" ||
        vps.operatingSystem === "Operating System - CentOS"
          ? options
              .filter((opt) => !opt.name.includes("cPanel"))
              .map((opt) => (
                <option value={opt.id} key={opt.id} id={opt.name}>
                  {label === "Operating System"
                    ? opt.name.split(" - ")[1]
                    : opt.name}
                </option>
              ))
          : vps.operatingSystem ===
              "Operating System - Windows Server Standard" ||
            vps.operatingSystem ===
              "Operating System - Windows Server Datacenter"
          ? options
              .filter(
                (opt) =>
                  !opt.name.includes("cPanel") &&
                  !opt.name.includes("DirectAdmin")
              )
              .map((opt) => (
                <option value={opt.id} key={opt.id} id={opt.name}>
                  {label === "Operating System"
                    ? opt.name.split(" - ")[1]
                    : opt.name}
                </option>
              ))
          : vps.operatingSystem === "Operating System - Fedora" ||
            vps.operatingSystem === "Operating System - FreeNAS" ||
            vps.operatingSystem === "Operating System - FreeBSD" ||
            vps.operatingSystem === "Operating System - Mikrotik"
          ? options
              .filter(
                (opt) =>
                  !opt.name.includes("cPanel") &&
                  !opt.name.includes("DirectAdmin") &&
                  !opt.name.includes("Plesk") &&
                  !opt.name.includes("ISPManager")
              )
              .map((opt) => (
                <option value={opt.id} key={opt.id} id={opt.name}>
                  {label === "Operating System"
                    ? opt.name.split(" - ")[1]
                    : opt.name}
                </option>
              ))
          : options.map((opt) => (
              <option value={opt.id} key={opt.id} id={opt.name}>
                {label === "Operating System"
                  ? opt.name.split(" - ")[1]
                  : opt.name}
              </option>
            ))}
      </>
    );
  };

  useEffect(() => {
    const checkAndRemoveAddon = (addonNames) => {
      const selectedProduct = productsList.find((product) => {
        return (
          product.vpsaddons &&
          product.vpsaddons.some((addon) => {
            return (
              addon.name && addonNames.some((name) => addon.name.includes(name))
            );
          })
        );
      });
      if (selectedProduct) {
        dispatch(removeVpsAddons({ pid: pidOnCart, input: "Control Panel" }));
      }
    };

    if (vps.operatingSystem === "Operating System - Debian") {
      checkAndRemoveAddon(["cPanel"]);
    } else if (
      vps.operatingSystem === "Operating System - Windows Server Standard" ||
      vps.operatingSystem === "Operating System - Windows Server Datacenter"
    ) {
      checkAndRemoveAddon(["cPanel", "DirectAdmin"]);
    } else if (
      vps.operatingSystem === "Operating System - Fedora" ||
      vps.operatingSystem === "Operating System - FreeNAS" ||
      vps.operatingSystem === "Operating System - FreeBSD" ||
      vps.operatingSystem === "Operating System - Mikrotik"
    ) {
      checkAndRemoveAddon(["cPanel", "DirectAdmin", "Plesk", "ISPManager"]);
    }
    // eslint-disable-next-line
  }, [vps.operatingSystem, currentBundlingPanel]);

  return (
    <div className="mb-4">
      <Form.Label className="fw-bold mb-3">{label}</Form.Label>
      <Form.Select onChange={optionHandler} disabled={false} value={optValue}>
        <AddonOptions data={listData} label={label} />
      </Form.Select>
    </div>
  );
};

export default AddonsVPSDropdown;
